import { render, staticRenderFns } from "./InventoryC.vue?vue&type=template&id=5f2f4f18&scoped=true&"
import script from "./InventoryC.vue?vue&type=script&lang=js&"
export * from "./InventoryC.vue?vue&type=script&lang=js&"
import style0 from "./InventoryC.vue?vue&type=style&index=0&id=5f2f4f18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2f4f18",
  null
  
)

export default component.exports